<template>
  <div class="repairReq-main">
    <div class="repairReq-main-header">
      <p class="font-format-big text-center">请填写详细的案例信息</p>
    </div>
    <div class="repairReq-main-step2">
      <!-- <el-row class="repairReq-main-step2-row">
        <el-col
          :xl="8"
          :lg="8"
          :md="8"
          :sm="24"
          class="repairReq-main-step2-left"
        >
          <p class="font-format-normal">请选择服务类型</p>
        </el-col>
        <el-col
          :xl="14"
          :lg="14"
          :md="14"
          :sm="24"
          class="repairReq-main-step2-right"
        >
          <el-radio-group v-model="serviceType">
            <el-radio
              v-for="item in serviceTypeOpts"
              :key="item.value"
              :label="item.value"
            >
              <span class="font-format-normal">{{ item.label }}</span>
            </el-radio>
          </el-radio-group>
        </el-col>
      </el-row> -->
      <el-form :model="device" ref="form" :rules="rules" label-position="top">
        <el-row class="repairReq-main-step2-row">
          <el-col :xl="8" :lg="8" :md="8" :sm="24" class="repairReq-main-step2-left">
            <p class="font-format-normal">请填写您设备信息</p>
          </el-col>
          <el-col :xl="14" :lg="14" :md="14" :sm="24" class="repairReq-main-step2-right">
            <el-form-item label="序列号" prop="sn">
              <el-input
                v-model="device.sn"
                placeholder="请输入序列号（序列号在产品外包装，保修卡，产品后壳位置）"
                clearable
              ></el-input>
              <p style="color: red">
                注：序列号为8-14位数字和字母，可在机器系统设置/机器后壳/保修卡上查询
              </p>
            </el-form-item>
            <el-form-item label="开机密码">
              <el-input
                v-model="device.powerOnPass"
                placeholder="如有开机密码一定需要填写，没有可不填"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="购买日期（保修期内产品需上传购买凭证）" prop="purTime">
              <el-date-picker
                v-model="device.purTime"
                type="date"
                class="afterSale-input afterSale-date-picker"
                placeholder="选择日期"
                :picker-options="pickerOptions"
                @change="getPurTime"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item v-if="showPurchases" label="购买凭证" prop="purchases">
              <div class="repairReq-main-upload" style="margin-top: 0">
                <input
                  type="file"
                  v-show="false"
                  accept=".jpeg, .jpg, .png, .bmp, image/*"
                  @change="handleChange($event, 'purchases')"
                  ref="purchases"
                />
                <el-button type="primary" @click="$refs.purchases.click()" :disabled="uploadStart"
                  >购买凭证上传</el-button
                >
                <div class="repairReq-main-upload-img" v-if="device.purchases.length">
                  <div
                    class="repairReq-main-upload-item"
                    v-for="(item, index) in device.purchases"
                    :key="index"
                    @click="getOssAttachsUrl(item)"
                  >
                    <p class="font-format-medium2 omitText">{{ item.name }}</p>
                    <i
                      class="el-icon-delete"
                      @click.stop="handleRemovePurchasesFile(item, index)"
                    ></i>
                  </div>
                </div>
                <el-progress
                  v-if="uploadStart && uploadRef === 'purchases'"
                  type="line"
                  :percentage="percentage"
                  :stroke-width="6"
                ></el-progress>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="repairReq-main-step2-row">
          <el-col :xl="8" :lg="8" :md="8" :sm="24" class="repairReq-main-step2-left">
            <p class="font-format-normal">您的设备遇到了什么问题？</p>
          </el-col>
          <el-col :xl="14" :lg="14" :md="14" :sm="24" class="repairReq-main-step2-right">
            <!-- <div
            class="repairReq-main-fault"
            v-for="(item, index) in faultData"
            :key="index"
          >
            <p class="repairReq-main-fault-title font-format-medium">
              {{ item.title }}
            </p>
            <div class="repairReq-main-fault-list">
              <div
                class="repairReq-main-fault-item"
                v-for="(data, idx) in item.list"
                :key="idx"
              >
                <p class="font-format-medium">{{ data.title }}</p>
              </div>
            </div>
          </div> -->

            <el-form-item
              label="请将阅读器的外观（包括正面屏幕以及背面后壳）及问题描述的清晰图片或视频，进行拍照上传"
              prop="desc"
            >
              <el-input
                class="font-format-medium2"
                type="textarea"
                v-model="device.desc"
                :rows="4"
                placeholder="请填写故障相关描述"
              >
              </el-input>
            </el-form-item>

            <div class="repairReq-main-upload">
              <input
                v-if="$route.query.t"
                type="file"
                v-show="false"
                accept=".jpeg, .jpg, .png, .bmp, image/*, video/*"
                @change="handleChange($event, 'attachs')"
                ref="attachs"
              />
              <input
                v-else
                type="file"
                v-show="false"
                accept=".jpeg, .jpg, .png, .bmp, image/*, video/*"
                @change="handleChange($event, 'attachs')"
                ref="attachs"
              />
              <el-button type="primary" @click="$refs.attachs.click()" :disabled="uploadStart"
                >附件上传</el-button
              >

              <div class="repairReq-main-upload-img" v-if="params.attachs.length">
                <div
                  class="repairReq-main-upload-item"
                  v-for="(item, index) in params.attachs"
                  :key="index"
                  @click="getOssAttachsUrl(item)"
                >
                  <p class="font-format-medium2 omitText">{{ item.name }}</p>
                  <i class="el-icon-delete" @click.stop="handleRemoveFile(item, index)"></i>
                </div>
              </div>
              <el-progress
                v-if="uploadStart && uploadRef === 'attachs'"
                type="line"
                :percentage="percentage"
                :stroke-width="6"
              ></el-progress>
            </div>
            <div class="repairReq-main-fault-service">
              <div class="repairReq-main-fault-companyInfo">
                <div class="repairReq-main-fault-companyInfo-left">
                  <p class="font-format-medium2 repairReq-main-fault-title">
                    此问题或许可以通过联系在线客服得到解决
                  </p>
                  <p class="font-format-medium2">联系人：文石售后维修</p>
                  <p class="font-format-medium2">电话：4008-860-830</p>
                </div>
                <div class="repairReq-main-fault-companyInfo-right">
                  <!-- <p class="font-format-medium">BOOX售后维修客服：</p> -->
                  <img src="@/assets/imgs/onlineCustomerService.png" alt="" />
                </div>
              </div>
              <!-- <div class="repairReq-main-faul-continue">
              <p class="font-format-medium2">已尝试联系在线支持,未能解决问题</p>
              <el-button type="default" size="default">继续送修</el-button>
            </div> -->
            </div>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="repairReq-step2-next">
      <el-button class="repairReq-step2-next-goBack" type="text" @click="goBack"
        >返回上一步</el-button
      >
      <el-button type="primary" size="default" @click="submitForm('form')">下一步</el-button>
    </div>

    <!-- 附件预览 -->
    <el-image v-show="false" ref="elImage" :preview-src-list="srcList"></el-image>
    <div class="video-component" v-if="showVideo" @click="closeVideo()">
      <div class="video-close-btn" @click.stop="closeVideo()">
        <i class="el-icon-close"></i>
      </div>
      <video controls @click.stop class="video-main">
        <source :src="videoSrc" />
      </video>
    </div>
    <!--  -->
  </div>
</template>

<script>
export default {
  props: {
    device: {
      type: Object
    },
    params: {
      type: Object
    }
  },
  computed: {
    rules() {
      let rules = {
        desc: [{ required: true, message: '故障描述不能为空', trigger: 'change' }],
        sn: [{ required: true, message: '序列号不能为空', trigger: 'change' }],
        purTime: [{ required: true, message: '购买日期不能为空', trigger: 'change' }]
      }
      return rules
    }
  },
  data() {
    return {
      serviceType: 1,
      serviceTypeOpts: [
        {
          label: '维修',
          value: 1
        },
        {
          label: '换货',
          value: 2
        },
        {
          label: '退货',
          value: 3
        }
      ],
      faultData: [
        {
          title: '硬件故障',
          list: [
            {
              title: '落水毁坏'
            },
            {
              title: '电池问题'
            },
            {
              title: '碰撞毁坏'
            },
            {
              title: '碰撞毁坏碰撞毁坏碰撞毁坏'
            },
            {
              title: '屏幕问题屏幕问题屏幕问题屏幕问题屏幕问题'
            },
            {
              title: '屏幕问题'
            },
            {
              title: '按键问题'
            },
            {
              title: '触控问题'
            }
          ]
        },
        {
          title: '软件问题或其他',
          list: [
            {
              title: '固件升级失败'
            },
            {
              title: '配件故障'
            },
            {
              title: '激活问题'
            },
            {
              title: '固件升级失败'
            },
            {
              title: '其他'
            }
          ]
        }
      ],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6
        }
      },
      uploadRef: '',
      isPreview: false,
      fileArr: [],
      srcList: [],
      videoSrc: '',
      ossClient: null,
      attachments: [],
      showViewer: false,
      showVideo: false,
      percentage: 0,
      uploadStart: false,
      showPurchases: false
    }
  },
  methods: {
    // 检查文件数量是否 > 500
    checkFileCount(files) {
      let isExceed = this.params.attachs.length + files.length > 5
      if (isExceed) {
        let message = '当前限制只能上传 5 个文件'
        this.$message({
          message,
          type: 'error',
          showClose: true,
          duration: 3000
        })
      }
      return isExceed
    },

    // 检查文件大小
    checkFileSize(files) {
      let arr = []
      for (let item of files) {
        arr = [...arr, item.size]
      }
      let isLtSize = arr.some(size => size > 200 * Math.pow(1024, 2))

      if (isLtSize) {
        let message = '当前文件限制不能超过200M'
        this.$message({
          message,
          type: 'error',
          showClose: true,
          duration: 3000
        })
      }
      return isLtSize
    },

    handleChange(el, ref) {
      this.uploadRef = ref
      let files = [...el.target.files]
      this.selectFiles(files)
    },

    async selectFiles(files) {
      if (this.checkFileSize(files) || this.checkFileCount(files)) {
        this.$refs[this.uploadRef].value = ''
        return
      }

      this.ossClient = await this.getOssClient()
      for (let file of files) {
        let res = await this.fileUpload(file)
        if (this.uploadRef === 'purchases') {
          this.device[this.uploadRef] = [...this.device[this.uploadRef], res]
        } else if (this.uploadRef === 'attachs') {
          this.params[this.uploadRef] = [...this.params[this.uploadRef], res]
        }
      }
      this.$refs[this.uploadRef].value = ''
    },

    async fileUpload(file) {
      try {
        this.uploadStart = true
        let params = {
          size: file.size,
          name: file.name,
          format: file.name.split('.').pop(),
          path: `attachments/${this.uuid()}${new Date().getTime()}.${file.name.split('.').pop()}`,
          desc: ''
        }
        await this.ossClient.multipartUpload(params.path, file, {
          progress: p => {
            let progress = parseInt(p.toFixed(2) * 100)
            this.percentage = progress
          }
        })
        this.uploadStart = false
        this.percentage = 0
        return params
      } catch (error) {
        throw new Error(error)
      }
    },

    async getOssAttachsUrl(item) {
      let ossClient = await this.getOssClient()
      item.url = ossClient.signatureUrl(item.path, { expires: 3600 })
      if (['jpeg', 'jpg', 'png', 'bmp'].includes(item.format)) {
        this.srcList = [item.url]
        this.$refs.elImage.showViewer = true
      } else {
        this.videoSrc = item.url
        this.showVideo = true
      }
    },

    async getOssClient() {
      try {
        let res = await this.$http.getSts()
        let region = 'oss-cn-shenzhen'
        let bucket = 'onyx-work-order'
        let client = new OSS({
          region,
          bucket,
          accessKeyId: res.data.accessKeyId,
          accessKeySecret: res.data.accessKeySecret,
          stsToken: res.data.securityToken
        })
        return client
      } catch (error) {
        throw new Error(error)
      }
    },

    uuid() {
      return `${this.s4()}${this.s4()}${this.s4()}${this.s4()}${this.s4()}${this.s4()}${this.s4()}${this.s4()}`
    },

    s4() {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1)
    },

    getPurTime() {
      let start = new Date(this.device.purTime).getTime()
      let end = new Date().getTime()
      var day = parseInt((end - start) / (24 * 60 * 60 * 1000))
      if (day <= 365) {
        this.showPurchases = true
      } else {
        this.device.purchases = []
        this.showPurchases = false
      }
    },

    closeVideo() {
      this.showVideo = false
      this.videoSrc = ''
    },

    handleRemoveFile(file, index) {
      this.params.attachs.splice(index, 1)
    },
    handleRemovePurchasesFile(file, index) {
      this.device.purchases.splice(index, 1)
    },

    submitForm(formName) {
      if (this.showPurchases && !this.device.purchases.length) {
        this.$message({
          message: '请上传购买凭证',
          type: 'error',
          duration: 3000
        })
        return
      }
      if (!this.params.attachs.length) {
        this.$message({
          message: '请上传附件',
          type: 'error',
          duration: 3000
        })
        return
      }
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.nextPage()
        } else {
          return false
        }
      })
    },

    goBack() {
      this.$emit('goBack')
    },
    nextPage() {
      this.$emit('nextPage')
    }
  },
  mounted() {
    this.getPurTime()
  }
}
</script>

<style lang="scss">
.repairReq-main {
  .video-component {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background: rgba($color: #000000, $alpha: 0.3);
    display: flex;
    justify-content: center;
    align-items: center;
    > .video-close-btn {
      position: absolute;
      top: 40px;
      right: 40px;
      width: 40px;
      height: 40px;
      font-size: 24px;
      color: #fff;
      background-color: #606266;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 50%;
      opacity: 0.8;
      cursor: pointer;
      box-sizing: border-box;
    }
  }
  .repairReq-main-header {
    text-align: center;
    border-bottom: 1px dashed #eee;
    padding: 30px 0;
  }
  .repairReq-main-step2 {
    /* border-bottom: 1px solid #eee; */
    .repairReq-main-step2-row + .repairReq-main-step2-row {
      border-top: 1px dashed #eee;
    }
    .repairReq-main-step2-row {
      padding: 30px 0;
      .repairReq-main-step2-left {
        margin-right: 60px;
        > p + p {
          margin-top: 10px;
        }
      }
      .repairReq-main-step2-right {
        .repairReq-main-fault-title {
          margin-bottom: 20px;
        }

        .repairReq-main-fault + .repairReq-main-fault {
          margin-top: 20px;
        }
        .repairReq-main-fault {
          .repairReq-main-fault-list {
            display: flex;
            flex-wrap: wrap;
            .repairReq-main-fault-item {
              cursor: pointer;
              text-align: center;
              padding: 14px;
              margin: 0 10px 10px 0;
              border: 1px solid #eee;
            }
          }
        }

        .repairReq-main-upload {
          margin-top: 20px;
          .repairReq-main-upload-img {
            margin-top: 20px;
            > .repairReq-main-upload-item + .repairReq-main-upload-item {
              margin-top: 10px;
            }
            .repairReq-main-upload-item {
              display: flex;
              align-items: center;
              justify-content: space-between;
              padding: 2px 5px;
              cursor: pointer;
              overflow: hidden;
              > p {
                flex: 1;
              }
              > i {
                color: red;
              }
              &:hover {
                background: #f1f1f1;
              }
            }
          }
          .afterSale-imgPreview {
            position: fixed;
            width: 20px;
            height: 20px;
            left: -1000px;
            top: -1000px;
          }
        }
        .repairReq-main-fault-service {
          margin-top: 20px;
          padding-top: 20px;
          border-top: 1px dashed #eee;
          .repairReq-main-faul-continue {
            margin-top: 20px;
            > .el-button {
              margin-top: 10px;
            }
          }
          .repairReq-main-fault-companyInfo {
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            .repairReq-main-fault-companyInfo-right {
              margin-top: 10px;
              > img {
                width: 135px;
                height: auto;
              }
            }
          }
        }
      }
    }
  }

  .repairReq-step2-next {
    padding-top: 30px;
    border-top: 1px solid #eee;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #fff;
  }
}

@media (max-width: 1000px) {
  .repairReq-main-step2-right {
    margin-top: 20px;
    .repairReq-sn-input {
      flex-direction: column;
      > .el-input {
        width: 100% !important;
      }
      > .el-button {
        margin-top: 20px;
        width: 100% !important;
      }
    }
  }
}

@media (max-width: 700px) {
  .repairReq-step2-next {
    position: absolute;
    left: 0;
    bottom: 10px;
    border: 0 !important;
    padding-top: 0px !important;
    box-shadow: 0 -1px 8px 4px #eee;
    > .el-button {
      flex: 1;
      border-radius: 0;
    }
  }

  .video-main {
    width: 90%;
    height: 250px;
  }
}
</style>
